module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /home/adwant/sites/argus/shared/node_modules/axios/index.js
// module id = 131
// module chunks = 0